export default __webpack_public_path__ + "static/media/facebookEN.343719cd.jpeg";